import React from "react";
import { getServiceCodeList } from "../../helpers/backend_helper";
import CodeList from "./CodeList";
import ServiceDetail from "./ServiceDetail";

const ServiceList = ({ createRequest = 0 }) => (
  <CodeList
    createRequest={createRequest}
    listCodes={getServiceCodeList}
    DetailComponent={ServiceDetail}
    codeLabel="Service Code"
    codesLabel="Service Codes"
    categoryLabel="PRIMA Service Code"
    searchPlaceholder="Search service codes..."
    fileName="prima-service-codes"
  />
);

export default ServiceList;
